import React from 'react';
import styles from './Distributors.module.scss'
import DistributorsTable from "../../../components/DistributorsTable/DistributorsTable";
import {$t} from "../../../helpers/translator";

const AdminDistributors = () => {

    return (
        <div className={styles.container}>
            <DistributorsTable header={$t('global.menu.distributors')} userType={5}/>
        </div>
    )
}

export default AdminDistributors;

